import capitalizeFirstLetter from './capitalizeFirstLetter';

const normalizeLabel = (label) => {
  if (!label) return null;
  return label.split(' ').filter(Boolean).map(capitalizeFirstLetter).join(' ');
};

export default normalizeLabel;
